import * as React from "react";
import "./index.css";
import ModalBase from "../../ModalBase";
import { TxReceiptTile } from "../../../Tiles";
import AdTileImage from "../../../../images/ad-tile-image.png";
import { useGetClassifiedByUserQuery } from "../../../../features/supabase/usecase/classifieds";
import storageService from "../../../../app/services/storageService";
import { useNavigate } from "react-router-dom";

const TxReceiptModal = ({ isOpen, onClose }) => {
  const { data: result, error, isLoading } = useGetClassifiedByUserQuery();

  const router = useNavigate();

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title={"Transaction Receipt"}>
      <div className="tx-rec-modal-base">
        <span className="tx-rec-modal-title">Transaction reciepts</span>
        <div className="tx-receipt-body">
          <div className="header row">
            <span className="cell">Headline</span>
            <span className="cell">Post date</span>
            <span className="cell">Cost</span>
          </div>
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
              }}
            >
              <span className="loader" />
            </div>
          )}
          {result &&
            result.map((classifeid, i) => (
              <TxReceiptTile
                index={i}
                key={i}
                title={classifeid.title}
                date={new Date(classifeid.created_at).toLocaleDateString()}
                cost={((classifeid?.invoice?.total ?? 0) / 100).toFixed(2)}
                image={
                  classifeid.properties &&
                  classifeid.properties.images.length > 0
                    ? `${storageService.publicUrl(
                        classifeid.properties.images[0]
                      )}`
                    : AdTileImage
                }
                onClick={() => {
                  router(`/listing/${classifeid.id}`);
                  onClose();
                }}
              />
            ))}
        </div>
      </div>
    </ModalBase>
  );
};

export default TxReceiptModal;
